import { selectAnswers, useSelector } from '../state'
import { useEffect } from 'react'
import { trackUserClosingTheApp } from './tracker'

export const useDropOutAnalytics = () => {
  const answers = useSelector(selectAnswers)

  useEffect(() => {
    const onBeforeUnload = () => {
      trackUserClosingTheApp(answers)
    }

    // N.B. Some browsers won't accept to do anything fancy when the User closes the tab/window, and each of them
    // has its own policy when they determine whether this event should be triggered.
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [answers])
}
